import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from "../InputComponent"
import { LanguageFactory} from '../../factories';
import { useLanguage } from '../../store/languageContext'
import SearchDebounceBar from '../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../factories/propertySearchs';
import {Table } from 'antd';
import Paper from '@material-ui/core/Paper';
import Loading from "@components/Loading"

interface propTypes {
    configuration: Array<{}>,
    data: Array<object | any>,
    onCLickRow: (e: object) => void,
    search?: {label: string, placeholder: string}
    isLoading?:boolean
}


const AnTable = (props: propTypes) => {
    const { language, setLanguage } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [dataSource, setDataSource] = useState<object[]>([]);
    const [total, setTotal] = useState(dataSource.length)
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()


    useEffect(() => {
        let data = props.data
        data.forEach((item: any, index: number) => { item.key = '' + index; })
        setDataSource(data)
    }, [props.data])

    useEffect(() => {
        setTotal(dataSource.length)
    }, [dataSource])

    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
   
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const filterData = async (query: string) => {
        let filterData = props.data.filter((item: any) => {
            const itemData: any = {}
            props.configuration.forEach((col: any) => {
                if (item[col.dataIndex]) {
                    itemData[col['dataIndex']] = item[col.dataIndex].toString().toLowerCase();
                }
            })
            return JSON.stringify(Object.values(item))
            .toLocaleLowerCase()
            .indexOf(query.toLocaleLowerCase()) > -1;

        })
        filterData.forEach((item: any, index: number) => { item.key = '' + index; })
        
        setDataSource(filterData);
    }

    if (props.isLoading) return <Loading type='large' />

    return (
            <Grid container spacing={0} className="containerSpacing py-0">
                {props.search && props.search.label &&
                    <Grid item xs={4} className="pb-0 px-0 my-4 ">
                        <ImputComponent
                            className = 'SearchBar'
                            label= {props.search && props.search.label}
                            labelShrink = {true}
                            value = {searchTerm}
                            onChange={onChangeSearch}
                            placeholder={props.search && props.search.placeholder}
                            endAdornment={<SearchIcon style={{color: '#9a9a9a'}}/>}
                        />
                        <div className="recentlySearchs">
                            <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                        </div>
                    </Grid>
                    }
                    <Grid item xs={12} className="p-0">
                        <Paper elevation={0} square className="containerSpacing py-1">
                            <Table
                                columns={props.configuration}
                                dataSource={
                                    dataSource
                                }
                                pagination={{
                                    size: "small",
                                    total,
                                    showSizeChanger: true,
                                    showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                                    defaultPageSize: 10,
                                    defaultCurrent: 1,
                                    onChange: (page, pageSize) => {
                                        console.log(page + '===' + pageSize)
                                    }
                                }}
                                onRow={record => {
                                    return {
                                        onClick: event => {
                                            props.onCLickRow(record)
                                        },
                                    };
                                }}
                            />
                        </Paper>
                    </Grid>
            </Grid>
    )
}

export default AnTable;
